import { Component, inject, input, output } from '@angular/core';
import { IconComponent } from '../icon.component';
import { provideIcons, provideNgIconLoader, withCaching } from '@ng-icons/core';
import { heroChatBubbleOvalLeft, heroHeart } from '@ng-icons/heroicons/outline';
import { DecimalPipe, NgStyle } from "@angular/common";
import { heroHeartSolid } from "@ng-icons/heroicons/solid";
import { ReactionType } from "../../../my-history/story/story";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-icons',
  standalone: true,
  imports: [IconComponent, NgStyle, DecimalPipe],
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss'],
  providers: [
    provideIcons({ heroHeartSolid, heroHeart, heroChatBubbleOvalLeft }),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
})
export class IconsComponent {
  guest = input(false);
  heartCounter = input<number | undefined>();
  isLiked = input<boolean | undefined>(false);
  addedComment = input<boolean | undefined>(false);
  chatCounter = input<number | undefined>();
  iconClicked = output<ReactionType>();
  isPreviewMode = input(false);
  readonly = input<boolean>(false);

  onClicked(icon: ReactionType) {
    if (!this.readonly()) {
      this.iconClicked.emit(icon);
    }
  }

  protected readonly ReactionType = ReactionType;
}
